<template>
  <div >
    <div>
      <!-- 进仓 -->
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData"  size="mini" label-width="100px">
          <div class="formItemBox">
          <el-form-item label="入库单号:">
            <el-input class="ipt" v-model="formData.instockNo" placeholder="请输入入库单号" size="mini" >
            </el-input>
          </el-form-item>
          <el-form-item label="车辆号牌:">
            <el-input class="ipt" v-model="formData.instockPlateNumber" placeholder="请输入车号" size="mini" ></el-input>
          </el-form-item>
          <el-form-item label="进仓单号:">
            <el-input class="ipt" v-model="formData.inWarehouseNo" placeholder="请输入进仓单号" size="mini" ></el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select size="mini" filterable clearable placeholder="请选择一级货主" v-model="formData.primaryCustomerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select size="mini" clearable filterable placeholder="请选择二级货主" v-model="formData.customerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="确认时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.confirmTimeStart" size="mini" type="datetime" placeholder="选择确认时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="formData.confirmTimeEnd" size="mini" placeholder="选择确认时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP007B005" v-if="btnFlg[4]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP007B006" v-if="btnFlg[5]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP007B007" v-if="btnFlg[6]">导出</el-button>
          </el-form-item>
          <el-form-item>
            <span>
              总吨数：
              <span style="color: red">{{ allWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 20px">
              总件数：
              <span style="color: red">{{ allNumber }}</span> &nbsp;件
            </span>
          </el-form-item>
        </el-form>
      </div>
      <div :style="{height:h}">
        <el-table border center bordersize="mini" :data="tableData"  class="tableComent" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @selection-change="selectGoods">
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
          <el-table-column prop="organizationName" label="仓库名称" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="inWarehouseNo" label="进仓单号" width="220">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockTime" label="入库时间" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="200">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="过磅净重时间" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center" width="150">
          </el-table-column>

        </el-table>
      </div>
      <div class="pags">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  getVirtualBalingList,
  JfgetConfirmedExpList,
  getConfirmedExpNumber
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
export default {
  name: 'JCRecord',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      formData: {
        inWarehouseNo: '',
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        arrivalMethod: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      btnArr: [
        '00ZP007B001',
        '00ZP007B002',
        '00ZP007B003',
        '00ZP007B004',
        '00ZP007B005',
        '00ZP007B006',
        '00ZP007B007',
        '00ZP007B008',
        '00ZP007B009',
        '00ZP007B00A',
        '00ZP007B00B',
        '00ZP007B00C',
        '00ZP007B00D',
        '00ZP007B00E',
        '00ZP007B00F',
        '00ZP007B00G',
        '00ZP007B00H',
        '00ZP007B00I',
        '00ZP007B00J',
        '00ZP007B00K',
        '00ZP007B00L',
        '00ZP007B00M',
        '00ZP007B00N',
        '00ZP007B00O',
        '00ZP007B00P',
        '00ZP007B00Q',
        '00ZP007B00R',
        '00ZP007B00S',
        '00ZP007B00T',
        '00ZP007B00U'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectList: [],
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      allWeight: 0,
      allNumber: 0
    }
  },
  props: {
    JCVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 总吨数
    getConfirmedExpNumber () {
      getConfirmedExpNumber({
        inWarehouseNo: this.formData.inWarehouseNo,
        instockNo: this.formData.instockNo,
        instockPlateNumber: this.formData.instockPlateNumber,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        confirmTimeStart: this.formData.confirmTimeStart,
        confirmTimeEnd: this.formData.confirmTimeEnd,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        arrivalMethod: this.formData.arrivalMethod
      }).then(res => {
        console.log(res)
        if (res.length != 0) {
          this.allWeight = parseFloat(res.totalAllWeight.toFixed(6))
          // this.allWeight = res.totalAllWeight
          this.allNumber = res.totalNumber
        } else {
          this.allWeight = 0
          this.allNumber = 0
        }
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 列表查询
    JfgetConfirmedExpLists () {
      JfgetConfirmedExpList({
        inWarehouseNo: this.formData.inWarehouseNo,
        instockNo: this.formData.instockNo,
        instockPlateNumber: this.formData.instockPlateNumber,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        confirmTimeStart: this.formData.confirmTimeStart,
        confirmTimeEnd: this.formData.confirmTimeEnd,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.tableData.forEach(item => {
            item.allWeight = parseFloat(Number(item.allWeight).toFixed(6))
            item.weight = parseFloat(Number(item.weight).toFixed(6))
          })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.inDetailId) // id数组
        arry = Array.from(new Set(arry)) // 去重
        this.selectListId = arry.join(',') // 获取全部货物id
      })
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      // this.getControlAuditLists()
    },
    chaxun () {
      this.JfgetConfirmedExpLists()
      this.getConfirmedExpNumber()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.inWarehouseNo = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.confirmTimeStart = ''
      this.formData.confirmTimeEnd = ''
      this.formData.arrivalMethod = ''
      this.JfgetConfirmedExpLists()
      this.getVirtualBalingList()
      this.getConfirmedExpNumber()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportConfirmedExpList', {
          ...this.formData,
          instockStatus: '1'
        },
        '进仓记录信息表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetConfirmedExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetConfirmedExpLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/recordQuery')
    this.getRelationCustomerS()
    this.JfgetConfirmedExpLists()
    this.getConfirmedExpNumber()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 205 + 'px'
  }
}

</script>

<style lang="less" scoped>
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
